<af-main-container [title]="'i18n_af_afCentre' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false"
                   [buttonLabel]="showCreateButton && ('i18n_af_buttonCreateSubject' | translate)"
                   (buttonClickListener)="navigateToCreateSubject()">
    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                <ng-template matTabContent>
                    @if (activeTab === tab) {
                        @for (resetKey of [tabResetKey[activeTab]]; track resetKey) {
                            <af-full-table class="w-100 h-100"
                                           [filterFields]="filterFields"
                                           (tableUpdateListener)="loadSubject($event)"
                                           [dataSource]="dataSource"
                                           chipsFormControlName="category"
                                           [totalElements]="filterHolderService.getState(activeTab)?.response?.total"
                                           [filterEvent]="filterHolderService.getState(activeTab)?.tableEvent.filter"
                                           [pageEvent]="filterHolderService.getState(activeTab)?.tableEvent.page"
                                           [columnTranslationPrefixes]="{id: 'subject', name: 'firstNameOrTitle'}"
                                           [exportImportMode]="'subjects'"
                                           emptyStateIconName="ic_empty_state_no_data"
                                           emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
                                           emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleNewSearchResult"
                                           [totalElementsTranslationKey]="'i18n_af_labelTotalElementsSubject'"
                                           [placeholderContext]="filterHolderService.getState(activeTab).placeholderContext"/>
                        }
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
